import React from 'react';

import {NewLabel} from '/component/base/NewLabel';
import ActivationDate from '/component/partial/report/ActivationDate';
import CoachesListHeader from '/component/partial/report/CoachesListHeader';
import FcvCount from '/component/partial/report/FcvCount';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';
import {COACH_PROFILE} from '/enum/popover.enum';

import {ReportProps} from '../Report.types';

import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

export const BusinessBuilderCoachesContent = ({
  loadingData = {total: 0},
  recordsShowRecord = () => {},
}: ReportProps) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  if (!isReadyToLoad) {
    return null;
  }
  return (
    <ReportDataProvider
      {...reportPayload}
      dataRenderer={PeopleReportDataRenderer}
      hideAvatar={true}
      dataRendererProps={{
        listHeaderComponent: CoachesListHeader,
        personRoleComponent: FcvCount,
        personInfoComponent: ActivationDate,
        NewLabelComponent: NewLabel,
        onRecordPress: (reportData: any) => {
          recordsShowRecord({
            recordType: COACH_PROFILE,
            recordId: reportData.id,
          });
        },
        isCenterAlignedEvenlySpaced: true,
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params}]}
    />
  );
};
